import { render, staticRenderFns } from "./SubscriptionConfig.vue?vue&type=template&id=55cd0ac6&"
import script from "./SubscriptionConfig.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionConfig.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports